import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './site/pages/HomePage';
import AboutPage from './site/pages/AboutPage';
import ContactPage from './site/pages/ContactPage';
import PrivacyPolicyPage from './site/pages/PrivacyPolicyPage';
import TermsPage from './site/pages/TermsPage';
import CookiePolicyPage from './site/pages/CookiePolicyPage';
import CancellationRefundPage from './site/pages/CancellationRefundPage';
import ServiceFeesPage from './site/pages/ServiceFeesPage';
import DisclaimerPage from './site/pages/DisclaimerPage';
import AdvertiserDisclosurePage from './site/pages/AdvertiserDisclosurePage';
import NotFoundPage from './site/pages/NotFoundPage';
import AirlineLandingPage from './airline/SouthwestPage';
import AirlineFlightSearchPage from './airline/FlightSearchPage';
import { airlinePath, airlineResultsPath } from './airline/airlines';
import FlightApp from './flights/FlightApp';
import { FLIGHT_PAGE_META } from './constants/pageMeta';
import { applyPageMeta } from './utils/usePageMeta';

/** Scroll to the #section in the URL, or to the top on a new page */
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function AppRoutes() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Main site pages and the reservations help desk page set their own title/description
    if (pathname.startsWith('/flight')) applyPageMeta(FLIGHT_PAGE_META);
  }, [pathname]);

  return (
    <>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-and-conditions" element={<TermsPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/cancellation-refund-policy" element={<CancellationRefundPage />} />
        <Route path="/service-fees" element={<ServiceFeesPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="/advertiser-disclosure" element={<AdvertiserDisclosurePage />} />
        <Route path={airlinePath('airline')} element={<AirlineLandingPage slug="airline" />} />
        <Route path={airlineResultsPath('airline')} element={<AirlineFlightSearchPage slug="airline" />} />
        {/* Search results and booking pages; old /flight policy URLs redirect to the pages above */}
        <Route path="/flight/*" element={<FlightApp />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
